// extracted by mini-css-extract-plugin
module.exports = {"alarm_close":"modal_alarm_close__2aXXq","alarm_modal":"modal_alarm_modal__1nrQT","alarm_modal_lg":"modal_alarm_modal_lg__M4792","alarm_modal_bg":"modal_alarm_modal_bg__33XQO"};